import { axios } from '@Root/API'

export const confirmStudent = applicationId => {
	return axios.get(`confirm-student-application/${applicationId}`)
}
